<template>
    <PageTemplateContent>
        <BaseHero
            title="ICMJE standards"
            data-span-all
        />
        <ContentBlocksText>
            <p>
                To review best practice and ethical standards in the conduct and reporting of content and to publish, create and distribute accurate, clear, reproducible, unbiased educational material, the review process will be conducted according to the international committee of medical journal authors (ICMJE) standards. All content is peer reviewed by at least two independent medical professionals from the same or a neighboring medical subspecialty (peers).
            </p>
            <p>
                All content should have a clear educational purpose and all conflicts of interest should be documented, reviewed and transparently reported. Content uploaded or (co)authored directly or indirectly by the medical device or pharmaceutical industry will be reviewed and, if considered educational l, added to the commercial section of the platform. Content with specific 'instructions for use' can be both commercial and educational. Commercial videos without any educational value will be rejected for publication.
            </p>
            <h3>Educational content:</h3>
            <ul>
                <li>authored and uploaded by medical professionals</li>
                <li>merely demonstrating how to use a certain device or product (unsubstantiated claims of superiority not allowed, avoid commercial terms such as the only, new, latest, improved, most recent, innovative etc.)</li>
                <li>report conflicts of interest related to the device and/or company that produces or distributes the medical device</li>
            </ul>
            <h3>Commercial and educational content:</h3>
            <ul>
                <li>produced, authored and/or uploaded by industry directly or indirectly</li>
                <li>content has educational value regarding specific 'instructions for use', but also includes a commercial purpose, for example by claiming superiority over other treatments, techniques or devices (even if that other device is from the same company or group) or by advocating its use for specific indications</li>
            </ul>
            <h3>Commercial content (rejected for publication):</h3>
            <p>
                Content with insufficient educational value as judged by MedPeers and/or by the appointed reviewers will be rejected for publication. MedPeers has the right to replace or remove previously published data, should information become available that renders the content educational but also commercial (for example replacing the content educational section to the commercial section) or fully commercial (content will be removed).
            </p>
        </ContentBlocksText>
    </PageTemplateContent>
</template>

<script setup>
const { asset } = useBaseUrl();

useSeoMeta({
    title: 'MedPeers | ICMJE standards',
    description: 'A secure, peer-reviewed and quality-controlled platform offering educational videos of  medical procedures.',
    ogImage: asset('/images/og/default.png')
});
</script>
